<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='user_keyword'>
          <a-input-group compact style="width:320px;">
            <a-select v-model:value="search.user_key_type" style="width:35%">
              <a-select-option value="clerk_name">领奖用户</a-select-option>
              <a-select-option value="member_name">微信昵称</a-select-option>
            </a-select>
            <a-input style="width: 65%" placeholder="请输入关键词" v-model:value="search.user_keyword" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="" name='keyword'>
          <a-input-group compact style="width:320px;">
            <a-select v-model:value="search.code_key_type" style="width:35%">
              <a-select-option value="batch_sn">码批次</a-select-option>
              <a-select-option value="product_code">码ID</a-select-option>
              <a-select-option value="code_sn">流水号</a-select-option>
            </a-select>
            <a-input style="width: 65%" placeholder="请输入关键词" v-model:value="search.code_keyword" />
          </a-input-group>
        </a-form-item>
        <a-form-item ref="" label="导购活动" name="">
          <a-input  placeholder="请选择活动" style='width:200px' v-model:value="search.activity"></a-input>
        </a-form-item>
        <a-form-item ref="" label="商品名称" name="">
          <a-input placeholder="请输入商品名称" style='width:200px' v-model:value="search.product"></a-input>
        </a-form-item>
        <a-form-item label="中奖时间" name='time'>
          <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" v-model:value="time" />
        </a-form-item>
        <a-form-item >
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='scan_id' :columns='columns' :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
          <template v-slot:member="{ record }">
            <div class="s_flex_ali">
              <img class="width-50 height-50 m-r-15" :src="record.member_img ? record.member_img : require('@/assets/images/group.png')" alt="" />
              <div>
                <p>{{record.member_name || '-'}}</p>
                <!-- <p>ID：{{record.member_id}}</p> -->
              </div>
            </div>
          </template>
          <template v-slot:product="{ record }">
            <div class="s_flex_ali" v-if="record.product_name">
              <img class="width-50 height-50 m-r-15" :src="record.product_img ? info.picdomain+record.product_img : ''" alt="" />
              <div>
                <p>{{record.product_name || '-'}}</p>
                <!-- <p>ID：{{record.member_id}}</p> -->
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
          <template v-slot:code_sn="{ record }">
            <p>{{record.product_code}}</p>
            （{{record.code_sn}}）
          </template>
          <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:guideScanLogsDetail="()=>{showMore = true;scan_id = record.scan_id}">详情</a>
          </template>
        </a-table>
        <a-pagination :show-total="total => `总数:${total} `" :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
      </div>
    </a-card>
  </a-layout>
  <!-- 活动弹窗 -->
  <a-modal v-model:visible="activityVisible" centered style="width:700px" :width='1000' :footer="null">
    <selectActivity v-on:select="activitySelect" :checkout='false' />
  </a-modal>
  <!-- 商品弹窗 -->
  <a-modal :keyboard="false" v-model:visible="productVisible" centered :footer="null" style="width:700px" :width='1000'>
    <selectGood v-on:select="goodSelect" :selectList='[{id:search.product_id}]'></selectGood>
  </a-modal>
  <a-modal :keyboard="false" title="扫码明细详情" centered v-model:visible="showMore" :width='1200' :footer="null" destroyOnClose>
    <scanMore type='scan' scanname='dealer' :id='scan_id'></scanMore>
  </a-modal>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { iscode } from "@/utils/app";
import { getdealer_scanScanList } from "@/api/guide";
import scanMore from './detail.vue'
import store from '@/store'
const def = {
  page: 1,
  page_num: 10,
  activity: "",
  product: "",
  user_key_type: "clerk_name",
  user_keyword: "",
  code_key_type: "code_sn",
  code_keyword: "",
};
export default {
  name: "award",
  components:{scanMore},
  setup() {
    const state = reactive({
      info:store.state.user.info,
      vipList: [],
      listLoading: false,
      total: 0,
      visible: false,
      time: [],
      totalData: {},
      scan_id: "",
      showMore: false,
    });
    let list = ref();

    let columns = [
      {
        title: "码ID",
        dataIndex: "code_sn",
        key: "code_sn",
        slots: { customRender: "code_sn" },
      },
      {
        title: "领奖用户",
        dataIndex: "clerk_name",
        key: "clerk_name",
      },
      {
        title: "微信昵称",
        dataIndex: "member",
        key: "member",
        slots: { customRender: "member" },
      },
      {
        title: "扫码结果",
        dataIndex: "scan_num_text",
        key: "scan_num_text",
      },
      {
        title: "商品名称",
        dataIndex: "product_name",
        key: "product_name",
        slots: { customRender: "product" },
        width:300
      },
      {
        title: "导购活动",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "扫码时间",
        dataIndex: "created_time",
        key: "created_time",
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const initData = async () => {
      state.listLoading = true;
      list.value = [];
      let res = await getdealer_scanScanList({...search.value}).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        list.value = res.data;
        state.totalData = res.total;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    onMounted(() => {
      initData();
    });
    const $router = inject("$router");
    // 时间筛选
    const onChange = (e) => {
      if (!e) {
        search.value.start_time = "";
        search.value.end_time = "";
        return;
      }
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    // 活动弹窗
    const activityVisible = ref(false);
    const activitySelect = (data) => {
      search.value.activity_id = data.activity_id;
      search.value.activity_name = data.activity_name;
      activityVisible.value = false;
    };
    // 商品弹窗
    const productVisible = ref(false);
    const goodSelect = (data) => {
      search.value.product_name = data.product_name;
      search.value.product_id = data.id;
      productVisible.value = false;
    };
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      activityVisible,
      activitySelect,
      productVisible,
      goodSelect,
    };
  },
};
</script>